/* import __COLOCATED_TEMPLATE__ from './attribute-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { copy } from 'ember-copy';
import { scheduleOnce } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class AttributeEditor extends Component {
  @service intercomConfirmService;
  @service intl;
  @service notificationsService;
  @service appService;
  @tracked copiedValue;

  get app() {
    return this.appService.app;
  }

  constructor() {
    super(...arguments);
    this.copiedValue = copy(this.args.value);
  }

  focus(element) {
    element.focus();
    element.select();
  }

  async completeUpdate() {
    // Only show confirmation modal for company attributes
    if (this.args.isCompanyAttribute) {
      let attributeName = this.args.attribute?.name || 'attribute';
      let options = {
        title: this.intl.t('people.attributes.edit-modal.edit-company-attributes.title', {
          attributeName,
        }),
        confirmButtonText: this.intl.t(
          'people.attributes.edit-modal.edit-company-attributes.confirm',
        ),
        cancelButtonText: this.intl.t(
          'people.attributes.edit-modal.edit-company-attributes.cancel',
        ),
        body: this.intl.t('people.attributes.edit-modal.edit-company-attributes.message-body'),
      };

      let isConfirmed = await this.intercomConfirmService.confirm(options);

      if (isConfirmed) {
        this.args.completeEditing(this.copiedValue);
      } else {
        this.copiedValue = copy(this.args.value);
      }
    } else {
      // For non-company attributes, update directly without confirmation
      this.args.completeEditing(this.copiedValue);
    }
  }

  @action
  cancelEditing() {
    this.copiedValue = this.args.value;
    this.args.cancelEditing();
  }

  @action
  async editingCompletedViaBlur() {
    scheduleOnce('afterRender', this, this.completeUpdate);
  }

  @action
  async editingCompletedViaEnter() {
    scheduleOnce('afterRender', this, this.completeUpdate);
  }
}
